import levelData from "./levels.json";
import GameStorage from "./GameStorage";

export const LevelDataEvents = {
  LEVEL_CHANGED: "levelChanged",
};

export default class LevelData {
  constructor() {
    this.emitter = new Phaser.Events.EventEmitter();

    this.storage = new GameStorage("zero_sums");

    this.currentLevel = 0;
    this.levels = levelData.levels;
    this.getLocalData();
  }

  getLevelAt(index) {
    return this.levels[index];
  }

  getLevelIsLocked(index) {
    return (
      this.levels[index].isLocked === true ||
      this.levels[index].isLocked === undefined
    );
  }

  setLevelIsLocked(index, val) {
    this.levels[index].isLocked = val;
  }

  unlockCurrentLevel() {
    this.setLevelIsLocked(this.currentLevel, false);
  }

  unlockNextLevel() {
    if (this.currentLevel < this.levels.length - 1) {
      this.setLevelIsLocked(this.currentLevel + 1, false);
    }
  }

  getCurrentLevelIsLocked() {
    return this.getLevelIsLocked(this.currentLevel);
  }

  getHighestUnlockedLevel() {
    for (let i = 0; i < this.levels.length; i++) {
      if (this.getLevelIsLocked(i)) {
        return i - 1;
      }
    }
    return this.getTotalLevels();
  }

  setLevel(index, doNotDispatchEvent) {
    this.currentLevel = index;
    if (!doNotDispatchEvent) {
      this.emitter.emit(LevelDataEvents.LEVEL_CHANGED);
    }
  }

  nextLevel() {
    if (this.currentLevel < this.levels.length - 1) {
      this.currentLevel++;
      this.emitter.emit(LevelDataEvents.LEVEL_CHANGED);
      return true;
    }
    return false;
  }

  previousLevel() {
    if (this.currentLevel > 0) {
      this.currentLevel--;
      this.emitter.emit(LevelDataEvents.LEVEL_CHANGED);
    }
  }

  getCurrentLevelIndex() {
    return this.currentLevel;
  }

  getTotalLevels() {
    return this.levels.length;
  }

  getCurrentLevelData() {
    return this.levels[this.currentLevel];
  }

  getLocalData() {
    const lockedLevels = this.storage.getValue("lockedLevels");
    if (lockedLevels) {
      for (let i = 0; i < lockedLevels.length; i++) {
        const locked = lockedLevels[i];
        this.levels[i].isLocked = locked;
        if (locked) {
          this.currentLevel = i - 1;
        }
      }
    }
  }

  saveToLocal() {
    const lockedLevels = [];
    for (let i = 0; i < this.levels.length; i++) {
      const locked = this.levels[i].isLocked;
      lockedLevels[i] =
        locked === undefined || locked === null || locked === true
          ? true
          : false;
    }
    this.storage.setValue("lockedLevels", lockedLevels);
  }

  resetProgress() {
    this.levels[0].isLocked = false;
    for (let i = 1; i < this.levels.length; i++) {
      this.levels[i].isLocked = true;
    }
    this.currentLevel = 0;
    this.saveToLocal();
  }

  setInstructionsHaveBeenSeen(val) {
    this.instructionsHaveBeenSeen = val;
  }

  getInstructionsHaveBeenSeen() {
    return this.instructionsHaveBeenSeen;
  }
}
